<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western" id="calibre_pb_9">CHAPTER TWO</h1>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2"> <br class="calibre2"/></p>
<p class="c9">Tuesday, November 6</p>
<p class="western2"><a id="ch_2"></a><br class="calibre2"/></p>
<p class="western2">At eight forty-five AM, Christine pushed open
the conference room door. She could smell the tantalizing aroma of
freshly brewed coffee and the sweetness of the donuts being
offered. She dropped her purse and briefcase on one of the tables
near the front of the room and headed for the coffee pot, hoping it
would help her hangover. Lois was still upstairs, sleeping.</p>
<p class="western2">Sipping the hot black brew, Christine picked
up her preprinted name badge and scanned the room from behind the
steaming cup before sitting down by her stuff. <i class="calibre4">There must be at
least thirty people here</i>, she thought, noticing the cute guy
and the geeky one. Not a surprise that this meeting was attended by
mostly females; guys just didn’t do office work and she envied
them, she hated paperwork.</p>
<p class="western2">To pass the time, she read the brochure from
the front desk. Apparently the hotel was still under construction
with the fourth floor incomplete. The flyer showed a taller
building and luscious landscaping with wandering paths, waterfall
pools, and benches. In another year it would be really nice.</p>
<p class="western2">The class started promptly at nine o’clock
with the usual introductions around the room. At nine-fifteen, Lois
strolled in, going straight to the food table. She spiked a cup of
coffee with three sugars and two creamers, picked up three donuts,
and ignored her name badge, which was the only one left on the
registration table.</p>
<p class="western2">“Why didn’t you wake me?” she whispered to
Christine, sitting down beside her.</p>
<p class="western2">“I tried.”</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="c4">***</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2">The speaker droned on and on for two hours,
discussing everything that was already in the handout while
flipping through the Power Point that showed on the large screen at
the front of the room. Christine took a few notes before noticing
no one else was. Her first assessment was right: it was a boring
class, and everything was explained in the neatly stapled stack of
papers in front of her.</p>
<p class="western2">“Okay, let’s take a fifteen minute break,”
the speaker announced. “We have one more hour to go on this morning
session, and then we’ll break for a one hour lunch, which will be a
sandwich buffet downstairs in the Coral Room adjacent to the
restaurant.”</p>
<p class="western2">“I hope he doesn’t mind if I have a beer with
that sandwich,” Lois said. She stood, stretching her back and
exposing the roll of pink flesh that bulged over her new hot pink
pants.</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="c4">***</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2">“This buffet is actually good,” Lois
commented to Christine. “Maybe because I can make my sandwich the
way I like it.” Christine looked over her shoulder to see Lois’
plate piled with macaroni salad, chips, and an over-stuffed
sandwich roll, thinking it was no small wonder the girl was so
overweight. Christine herself watched what she ate to maintain a
trim figure.</p>
<p class="western2">She waited until she saw Lois head to the bar
with her plate, then ducked out to take her lunch back upstairs for
some quiet reading.</p>
<p class="western2">Once in the conference room, Christine laid a
couple of opened paper napkins on the table to keep her place clean
and set her plate down. After retrieving a bottle of water from the
long refreshment table, she got out her latest romance novel from
the briefcase and settled in to read. A few minutes later, others
joined her, sitting individually around the room. They obviously
needed quiet time too, and that was just fine since she was in no
mood to carry on idle conversation.</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="c4">***</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2">“What was that?” an older woman sitting in
the back asked. Alarm laced her frightened voice.</p>
<p class="western2">Christine had felt a mild vibration, as if a
big truck had driven by. A big truck wouldn’t have been able to
rock the four-story hotel though. Another, stronger movement shook
the building and she looked around at the others in the room.
Everyone had stopped reading or eating and were gazing about.</p>
<p class="western2">“Those cars are skidding all over the road!”
Jerry, the geeky guy said, looking out the window, just as the
sound of a car crash echoed through the room. Christine moved to
the windows in time to see the pavement break and ripple.</p>
<p class="western2">“It’s an earthquake!” she tried to yell, but
her voice came out hushed and squeaky. The building shook
violently, causing everyone standing to fall, and the overhead
projection screen crashed to the floor. The geeky guy held onto the
sill to keep his balance and was rewarded by the window shattering
in his face. A large knife of glass protruding from his neck
effectively cut off his scream. He slumped to the floor in slow
motion, his eyes wide with shock. Christine looked on in disbelief,
frozen in terror by the sight of blood gushing from the wound,
blood that was now spreading toward where she sat on the floor
under the broken windows. She scooted away from the crimson puddle
in horror.</p>
<p class="western2">The older woman screamed.</p>
<p class="western2">“Somebody help him!” another woman
yelled.</p>
<p class="western2">Christine crawled away, cutting her palms on
bits of glass, adding droplets of blood to the already red smeared
floor. A few feet away, she finally stood on wobbly legs. The
shaking stopped and everything went silent, except for the first
woman sobbing.</p>
<p class="western2">“We need to get out of this building before
it collapses,” Christine said, making her way to the door as
another tremor shook the building.</p>
<p class="western2">“What about Jerry?” someone asked.</p>
<p class="western2">“Jerry is already dead,” Christine responded.
“Let’s get out of here and find someone in charge. They’ll know
what to do about… him.” She glanced at the body and shivered.</p>
<p class="western2">In the hallway, she pounded on the elevator
call buttons.</p>
<p class="western2">“We can’t take the elevator. What if the
power goes out while we’re in there and we get stuck? They say to
use the stairs only,” said a woman whose nametag read “Cheryl.”</p>
<p class="western2">Christine turned to the stairs with the lit
exit sign over it. She pushed, but the door wouldn’t move. “Give me
a hand,” she said, and two of the younger women leaned on the door
and together they opened the door only a foot.</p>
<p class="western2">“Anyone have a mirror?” Cheryl asked. “Maybe
we can see what’s blocking the door.”</p>
<p class="western2">“What good will that do? We still can’t get
out!” sobbed someone else.</p>
<p class="western2">Christine looked around and saw another exit
sign. “I’m going to try another door. I’ll be right back.”</p>
<p class="western2">The door opened with ease and she signed in
relief, until she stepped into the stairwell to see all the rubble
blocking their way down. The other women crowded the door behind
her. “We aren’t getting out this way either. Maybe we should just
wait for someone to come and rescue us. I’m sure it won’t be long.
FEMA always shows up.” Christine said confidently.</p>
<p class="western2">“FEMA? You’ve got to be kidding,” Cheryl
said. “Haven’t you been watching the news? They are all in New York
mopping up after that hurricane. They won’t be here for days, if
not weeks, and I, for one, am not waiting that long.”</p>
<p class="western2">Christine went back to the conference room
and sat down, scowling at Cheryl. Cheryl was right of course,
though Christine was not about to admit that. She pulled out her
cellphone to call 911 only to find all the circuits were busy.</p>
<p class="western2">“I’m not staying in here with a dead body,”
someone said, muffling a sob. Christine looked over at the windows,
realizing she had forgotten all about Jerry. She stood quickly,
knocking her purse on the floor, spilling the contents. She picked
up her keycard.</p>
<p class="western2">“My room is upstairs. Maybe we can get
through some of the rubble going up and at least we’ll have some
comfort while we wait,” she said. “Besides, I need to change my
shoes. These boots are killing my feet!”</p>
<p class="western2">The five women, led by Cheryl, entered the
stairwell cautiously.</p>
<p class="western2">“We better prop this door open in case there
are any more aftershocks, just to make sure we can get back in if
we need to,” Cheryl suggested. They pushed the heavy door flat
against the wall and moved a couple of fallen bricks against
it.</p>
<p class="western2">Everyone peered over the railing at the
blocked exit.</p>
<p class="western2">“That whole wall caved in,” someone
whispered. “I hope we don’t have to climb over all that.”</p>
<p class="western2">The stairwell was lit only by the lights over
the doorways, the dim shadow barely enough to see by as they
ascended to the third floor, avoiding the debris on the steps.
Cheryl pulled open the third floor door and the same two younger
ones piled the few chunks of concrete to hold it open.</p>
<p class="western2">Christine stepped into empty hallway, the
soft carpeting muffling their steps. She checked the numbers on the
first two doors and turned the other way toward her room.</p>
<p class="western2">“Where is everyone?” Cheryl asked.</p>
<p class="western2">“When we checked in yesterday the desk clerk
said we should have the floor to ourselves because they were at
only ten percent capacity. I guess that’s because it’s the middle
of the week, and middle of construction,” Christine informed her.
“Here we are,” she said when they got to the end of the long, quiet
hall. She slid her key card in and pushed the door open just as the
hall lights flickered and went out. The room was bathed in the
diffused sunlight coming from around the edges of the blackout
drapes. Christine inched her way to the lone window and shoved the
drapes aside, flooding the place with brightness.</p>
<p class="western2">“That’s better,” the older woman said,
nervously sitting on the edge of the bed. “I don’t like it too
dark.”</p>
<p class="western2"><i class="calibre4">Swell</i>, thought Christine, <i class="calibre4">my
flashlight is in the car</i>. She looked around the messy room and
thought again that Lois was a real slob. Christine had made her bed
as soon as she got up. Lois, on the other hand, had left the sheets
in a pile in the middle of the bed and her clothes were tossed onto
the only two chairs.</p>
<p class="western2">“Um, sorry about the mess. Lois got up late
and obviously didn’t pick up after herself,” she apologized, then
wondered why she was making excuses for that slob.</p>
<p class="western2">She picked up the in-house phone, surprised
she actually got a dial tone. Dialing the operator she waited and
waited. “No answer at the front desk.”</p>
<p class="western2">“So what are we going to do now?” someone
asked once they had all used the bathroom. Christine had already
changed into her new walking shoes, tossing the impractical boots
on a chair.</p>
<p class="western2">“Let’s find another stairway and see if we
can make it down,” Cheryl suggested. “And we better prop open this
door too, just in case.”</p>
<p class="western2">“Why? I still have the keycard,” Christine
protested.</p>
<p class="western2">Cheryl raised her eyebrows. “It won’t work
without electricity. We can get out; we just can’t get back
in.”</p>
<p class="western2">“Oh.”</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2">They followed the long, silent hall around
two turns before they came to another exit sign, indicating stairs.
Christine pushed on the door and it gave way easily.</p>
<p class="western2">“It sure is dark in there,” she said
nervously. Once again, they propped the door open with a few pieces
of fallen wall board, allowing a modicum of light to shine in.</p>
<p class="western2">Cheryl pulled a small flashlight out of the
large purse she had hung crosswise over her shoulders, casting a
narrow beam of weak light down the stairs.</p>
<p class="western2">“These look fairly clear. So we don’t wear
ourselves out needlessly, why don’t two of us go to the second
floor and see if the rest of the stairs are open, then the rest can
follow?” Cheryl suggested, already descending the first few steps,
Christine right behind her. They stepped over a few pieces of
broken wall and made it to the second floor without any problems.
After opening and securing that door for additional light, they
started on the next set of steps that would take them to the main
floor and hopefully the lobby.</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="c4">***</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2">Cheryl took a deep breath and pushed on the
long panic bar, opening the door into a wide vestibule near the
unmanned front desk.</p>
<p class="western2">“Yes!” they both shouted, giving each other a
high five.</p>
<p class="western2">“Let’s go get the others,” Christine
said.</p>
<p class="western2">Cheryl turned to her, handing over the tiny
flashlight. “You go get them. I’m outta here!”</p>
<p class="western2">“What? Wait! I thought this was a joint
effort?” Christine looked aghast at the middle-aged woman.</p>
<p class="western2">“I’ve got two kids and a husband at home that
I know are worried sick about me. I’m not going back now that I’m
free,” Cheryl said slyly. “You’re more than capable. Besides, you
still need to go back for your things in your room.” Cheryl darted
toward the lobby doors, her dark ponytail swinging.</p>
<p class="western2">“What a conniving bitch!” Christine groaned.
She took a moment to look around the vacant lobby. People were
still milling around outside like zombies. She headed toward the
bar wondering if Lois was still there. She pushed open the etched
glass doors to an empty room, and then let them close again,
wondering where her co-worker was.</p>
<p class="western2">She decided she may as well go get the other
women. She stopped at the registration desk looking for something
to write on; someone had to know about Jerry. After jotting a quick
note, she propped it up on the keyboard and spotted another, bigger
flashlight and took it.</p>
<p class="western2">The walk back up the stairs seemed longer and
more difficult. At the second floor, Christine stopped to catch her
breath and to make sure the door was still secured open.</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="c4">***</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2">“Oh, there you are. We were beginning to
think you had forgotten about us,” the older woman said. “Where’s
Cheryl? Is she alright?”</p>
<p class="western2">“Cheryl is fine, I guess. As soon as we got
to the first floor she bailed.”</p>
<p class="western2">“Bailed?”</p>
<p class="western2">“Took off, as in left, went home,” Christine
said angrily. “Here’s a flashlight to use. There’s very little
rubble on the steps, please be careful anyway. The second floor
door is open for light and so is the one at the bottom.”</p>
<p class="western2">“You’re not coming with us, dear?”</p>
<p class="western2">“I’ll be right behind you. I have to go back
to my room to get my things, and see if I can find Lois,” Christine
said.</p>
<p class="western2">“Well, you be careful. We’ll wait for you in
the lobby.”</p>
<p class="western2">“No, you should get outside, it’s probably
safer. I’ll see you in ten minutes, promise.” She smiled at the
older woman’s concern. She watched as the light bobbed along in the
darkness then disappeared.</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="c4">***</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2">It only took Christine a few minutes to get
back to her room, feeling stupid she hadn’t known about the keycard
needing electricity to work. She dragged her toiletries off the
sink and into a bag, shoving it into her open suitcase that she had
laid on the bed. Glancing at the pile of sheets on Lois’ bed, she
wondered again where her co-worker was. That was something to worry
about later. Right now she had to get her stuff and shopping bags
and get out of there.</p>
<p class="western2">With the boots and shoes out of their boxes,
all of the new purchases fit into one of the larger shopping bags,
which Christine attached to the handle of the wheeled suitcase.
Glancing at her watch, she saw it was already 1:00pm. She looped
her purse over her shoulder and with her hands now full of her
belongings, stepped into the hallway just as the second big
aftershock hit. She bumped against the wall and knocked the fire
extinguisher off its mount. Losing her balance, she hit her head on
the metal cylinder when she fell and lost consciousness.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk.ch.fixed.fc.tidied.stylehacked.xfixed_split_009.vue?4b08ce03